export const mock = {
  mall: 'https://yapi.macrocura.com/mock/206',
};

/**
 * mock地址
 * @param mockPath
 * @param url
 */
export const mockUrl = (mockPath: string, url: string): string => {
  return `${mockPath}${url}`;
};



// WEBPACK FOOTER //
// ./src/constants/Mock.ts